import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'

export default {
  name: 'CustomRateEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      customRateEditItem: null,
      mode: 'edit'
    }
  },
  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.customRateEditItem = {
        description: null,
        cost: null,
        defaultQuantity: 1
      }
    } else {
      this.mode = 'edit'
      const item = this.$store.getters.getCustomRateItemById(this.id)
      this.customRateEditItem = {...item}
    }
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()
      jsConn.toRoutePath = '/custom-rates'
      jsConn.formParams = {
        id: this.id,
        item: this.customRateEditItem
      }
      this.$store.dispatch('updateCustomRateItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push(jsConn.toRoutePath)
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
